var map = {
	"./btn_share_en.png": 3587,
	"./btn_share_es.png": 9170,
	"./btn_share_fr.png": 4569,
	"./btn_share_hi.png": 2296,
	"./btn_share_jp.png": 21,
	"./btn_share_kr.png": 3761,
	"./btn_share_mn.png": 698,
	"./btn_share_pl.png": 2959,
	"./btn_share_pt.png": 9868,
	"./btn_share_ru.png": 306,
	"./btn_share_th.png": 2696,
	"./btn_share_vi.png": 6621
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2451;